import debounce from "lodash/debounce";
export function initGlobalPageHeader() {
    function getElementFromAnchor(anchor) {
        var _a, _b;
        return document.getElementById((_b = (_a = anchor.getAttribute('href')) === null || _a === void 0 ? void 0 : _a.replace('#', '')) !== null && _b !== void 0 ? _b : '');
    }
    function isBetweenInclusive(num, min, max, buffer) {
        var _a;
        if (buffer === void 0) { buffer = 0; }
        if (min > max) {
            _a = [max, min], min = _a[0], max = _a[1];
        }
        return num >= (min - buffer) && num <= (max + buffer);
    }
    function isSectionLink(el) {
        return el.dataset.jsScrollLink === 'true';
    }
    function makeScrollLinkTargetTops() {
        return originalScrollLinks.map(function (el) {
            var _a, _b, _c;
            if (!isSectionLink(el)) {
                return null;
            }
            return Math.max(((_b = (_a = getElementFromAnchor(el)) === null || _a === void 0 ? void 0 : _a.offsetTop) !== null && _b !== void 0 ? _b : 0) - ((_c = fixedEl === null || fixedEl === void 0 ? void 0 : fixedEl.offsetHeight) !== null && _c !== void 0 ? _c : 0), 0);
        });
    }
    function updateScrollLinks(links, activeIdx) {
        links.forEach(function (el, elIdx) {
            var _a, _b;
            if (activeIdx === elIdx) {
                (_a = el.parentElement) === null || _a === void 0 ? void 0 : _a.classList.add('group', '-active');
            }
            else {
                (_b = el.parentElement) === null || _b === void 0 ? void 0 : _b.classList.remove('group', '-active');
            }
        });
    }
    function updateActiveLink(activeIdx, scrollLinkGroups) {
        scrollLinkGroups.forEach(function (group) {
            var _a;
            group.forEach(function (el) { var _a; return (_a = el.parentElement) === null || _a === void 0 ? void 0 : _a.classList.remove('group', '-active'); });
            if (group[activeIdx].dataset.jsScrollLink === 'true') {
                (_a = group[activeIdx].parentElement) === null || _a === void 0 ? void 0 : _a.classList.add('group', '-active');
            }
        });
    }
    function updateFixedGlobalHeader() {
        if (window.scrollY > globalPageHeaderBottom) {
            fixedEl.classList.add('-sticky-header-visible');
        }
        else {
            fixedEl.classList.remove('-sticky-header-visible');
        }
    }
    function scrollWindowToElement(destEl, topOffset) {
        if (topOffset === void 0) { topOffset = 0; }
        if (destEl) {
            window.scrollTo(0, Math.max(0, destEl.offsetTop - (topOffset)));
        }
        else {
            window.scrollTo(0, 0);
        }
        return false;
    }
    function initScrollLinks(scrollLinks, scrollLinkGroups) {
        scrollLinks.forEach(function (el, idx) {
            el.addEventListener('click', function (evt) {
                var _a;
                evt.preventDefault();
                var target = evt.currentTarget;
                window.location.hash = (_a = target.getAttribute('href')) !== null && _a !== void 0 ? _a : '';
                document.removeEventListener('scroll', handleScroll);
                scrollWindowToElement(getElementFromAnchor(target), fixedEl.offsetHeight + 180);
                updateActiveLink(idx, scrollLinkGroups);
                document.addEventListener('scroll', handleScroll);
            });
        });
    }
    function getLinkIdxByHash(hash, links, fallbackIdx) {
        var linkIdx = links.findIndex(function (el, idx) {
            if (!isSectionLink(el)) {
                return false;
            }
            return el.getAttribute('href') === hash;
        });
        return linkIdx > -1 ? linkIdx : fallbackIdx;
    }
    function handleScroll(evt) {
        var scrollPos = window.scrollY;
        //make sure its at most 50 pixels from current scroll position, generally fixing initial scroll from 0 to 2000px
        if (scrollPos > lastScrollPos) {
            // scrolling down
            lastScrollPos = Math.max(lastScrollPos, scrollPos - 50);
        }
        else {
            // scrolling up,
            lastScrollPos = Math.min(lastScrollPos, scrollPos + 50);
        }
        var transitionIdx = scrollLinkTargetTops.findIndex(function (top) {
            if (top === null) {
                return false;
            }
            return isBetweenInclusive(top, scrollPos, lastScrollPos, 20);
        });
        if (transitionIdx > -1) {
            updateScrollLinks(originalScrollLinks, transitionIdx);
            updateScrollLinks(fixedScrollLinks, transitionIdx);
        }
        updateFixedGlobalHeader();
        lastScrollPos = scrollPos;
    }
    function handleResize(evt) {
        scrollLinkTargetTops = makeScrollLinkTargetTops();
    }
    var globalPageHeaderEl = document.querySelector("[data-js-selector='page-head']");
    // if we aren't doing sticky thing, don't do anything to the page
    if (!globalPageHeaderEl || !globalPageHeaderEl.dataset.sticky) {
        return;
    }
    var fixedEl = globalPageHeaderEl.cloneNode(true);
    var globalContentEl = document.querySelector('.global-content');
    var lastScrollPos = 0;
    var globalPageHeaderBottom = globalPageHeaderEl.offsetTop + globalPageHeaderEl.offsetHeight;
    var originalScrollLinks = Array.from(document.querySelectorAll("[data-js-scroll-link]"));
    var fixedScrollLinks = Array.from(fixedEl.querySelectorAll("[data-js-scroll-link]"));
    var scrollLinkTargetTops = makeScrollLinkTargetTops();
    var scrollLinkGroups = [
        originalScrollLinks,
        fixedScrollLinks,
    ];
    // prevent automatic scrolling on refresh
    if (history.scrollRestoration) {
        history.scrollRestoration = 'manual';
    }
    // create duplicate of the page header
    document.body.appendChild(fixedEl);
    fixedEl.classList.add('group', '-sticky-header');
    var removableEls = Array.from(fixedEl.querySelectorAll("[data-remove-while-sticky]"));
    removableEls.forEach(function (el) {
        var _a;
        (_a = el.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(el);
    });
    // turn all h1s to h2s
    var h1s = Array.from(fixedEl.querySelectorAll('h1'));
    h1s.forEach(function (el) {
        var _a;
        var newEl = document.createElement('h2');
        newEl.innerHTML = el.innerHTML;
        newEl.className = el.className;
        (_a = el.parentNode) === null || _a === void 0 ? void 0 : _a.replaceChild(newEl, el);
    });
    // initialize links in the two page headers
    initScrollLinks(originalScrollLinks, scrollLinkGroups);
    initScrollLinks(fixedScrollLinks, scrollLinkGroups);
    // check if there is an initial active menu link in the hash
    var initialActiveIdx = getLinkIdxByHash(location.hash, originalScrollLinks, 1);
    if (initialActiveIdx !== 1) {
        scrollWindowToElement(getElementFromAnchor(originalScrollLinks[initialActiveIdx]), fixedEl.offsetHeight);
        updateActiveLink(initialActiveIdx, scrollLinkGroups);
    }
    // set up scroll and resize handlers
    document.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', debounce(handleResize, 100));
    // set up dom watcher so that things will recalc when react finishes loading in content
    if (globalContentEl) {
        var observer = new MutationObserver(debounce(handleResize, 100));
        observer.observe(globalContentEl, { subtree: true, childList: true });
    }
    // Update the status of the global header
    updateFixedGlobalHeader();
}
